export default "__VITE_ASSET__CKKj9J6a__"